import { EyeArrowRightIcon } from './EyeArrowRightIcon';

/**
 * author: Michael Irigoyen
 * id FFAF8600-64E9-4DEF-B689-D14B95B608CA
 * name eye-arrow-right
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/eye-arrow-right.svg
 * tags
 */
export const ViewArrowRightIcon = EyeArrowRightIcon;
export default ViewArrowRightIcon